export default __webpack_public_path__ + "static/media/parachute-logo-4x.cb21da47.png";